import React from "react";
import ElsaSplashVideo from "./ElsaSplashVideo";
import { ELSA_BRAND_ASSETS } from "../config/brandAssets";
import "./MobileSplashScreen.css";

const MobileSplashScreen = () => {
  return (
    <div
      className="mobile-splash-screen"
      role="status"
      aria-live="polite"
      aria-label="Chargement de ELSA GESTION"
    >
      <div className="mobile-splash-screen__media">
        <ElsaSplashVideo
          className="mobile-splash-screen__video"
          fallbackClassName="mobile-splash-screen__fallback-logo"
          fallbackSrc={ELSA_BRAND_ASSETS.logoHorizontalWhite}
          alt="ELSA GESTION — Gardez le contrôle, où que vous soyez."
        />
      </div>
      <span className="mobile-splash-screen__sr-only">
        Chargement de ELSA GESTION
      </span>
    </div>
  );
};

export default MobileSplashScreen;
